export default {
      id: "calendar-usage",
      viewBox: "0 0 12 14",
      url: "/" + "img/marilyn-ui.svg#calendar",
      toString: function () {
        return this.url;
      }
    }